import { capitalize, replaceWords, sortByProp } from '@Sage/ssm-utils';

import Core from 'managers/core';
import { CL_LANGUAGES } from 'constants/App';
import { t } from 'utils/getLiteral';

const FilterSchemaOnPreview = [
    {
        dataType: 'text',
        description: 'cfm_label_key_word',
        id: 'key',
    },
    {
        dataType: 'text',
        description: 'cfm_label_current_text',
        id: 'currentValue',
    },
    {
        dataType: 'text',
        description: 'cfm_label_new_text',
        id: 'newValue',
    },
];

const FilterSchemaInit = [
    {
        dataType: 'singleValueList',
        description: 'cfm_label_language',
        id: 'language',
        inputAttrs: {
            list: CL_LANGUAGES,
        },
    },
    {
        dataType: 'text',
        description: 'cfm_label_key_word',
        id: 'key',
    },
    {
        dataType: 'text',
        description: 'cfm_label_current_text',
        id: 'currentValue',
    },
];

export default class LiteralsManager {
    constructor(apiCFMLiterals, apiCFM) {
        this.apiCFMLiterals = apiCFMLiterals;
        this.apiCFM = apiCFM;
    }

    getFilterSchema = (subsection) => {
        if (subsection === 'preview') {
            return sortByProp(FilterSchemaOnPreview, 'description', t);
        }
        return sortByProp(FilterSchemaInit, 'description', t);
    };

    getLiterals = (lang, implId) =>
        new Promise((resolve, reject) => {
            this.apiCFMLiterals.getLiterals(lang, implId).then(
                (res) => {
                    if (res !== undefined && Object.keys(res).length > 0) {
                        Core.cacheManager.setLiteralsStore(res);
                        resolve(res);
                    } else {
                        reject();
                    }
                },
                (error) => reject(error),
            );
        });

    getLiteralsByImplementation = ({ page, search, count, replace, lang = 'es-es' }) =>
        new Promise((resolve, reject) => {
            let word = '';
            const { keyText, currentValueText } = search;

            if (keyText && keyText.length > 0) {
                word = keyText;
            } else if (currentValueText && currentValueText.length > 0) {
                word = currentValueText;
            }

            this.apiCFM.getLiteralsByImpl(page, word, count).then(
                (res) => {
                    if (!res) {
                        reject();
                        return;
                    }

                    let result = res;

                    // filtrar segun el whereSearch para limpiar la lista antes de enviarla al reducer
                    // eliminar los que tengan deprecatedDate informada
                    if (Object.keys(search).length > 0) {
                        if (keyText && keyText.length > 0) {
                            const keyLw = keyText.toLowerCase();
                            result = result.filter(
                                (literal) => literal.key.toLowerCase().indexOf(keyLw) !== -1,
                            );
                        }

                        if (currentValueText && currentValueText.length > 0) {
                            const searchLw = currentValueText.toLowerCase();
                            result = result.filter((literal) => {
                                const langLiteral = literal.languageValues[lang]
                                    ? literal.languageValues[lang].toLowerCase()
                                    : '';
                                return langLiteral.indexOf(searchLw) !== -1;
                            });
                        }
                    }

                    if (replace && replace.length > 0) {
                        // Con el objeto 'limpio' empiezo a generar las propuestas
                        // En primer lugar agrego dos nuevos campos al objeto 'isUpdate' y 'proposalValues'
                        result = result.map((item) => {
                            let proposalValues = item.languageValues[lang];
                            proposalValues = replaceWords(proposalValues, word, replace);

                            proposalValues = replaceWords(
                                proposalValues,
                                word.toLowerCase(),
                                replace.toLowerCase(),
                            );

                            proposalValues = replaceWords(
                                proposalValues,
                                capitalize(word),
                                capitalize(replace),
                            );

                            proposalValues = replaceWords(
                                proposalValues,
                                word.toUpperCase(),
                                replace.toUpperCase(),
                            );

                            return {
                                ...item,
                                isUpdate: false,
                                proposalValues,
                            };
                        });
                    }

                    const hasNextPage = word === '' && res.length >= count;
                    result = result.map((item) => ({
                        ...item,
                        dataTest: item.key,
                    }));

                    resolve({ list: result, hasNextPage, page });
                },
                (error) => {
                    reject(error);
                },
            );
        });

    updateLiteralsByImpl = (data, lang) =>
        new Promise((resolve, reject) => {
            const dataFiltered = data.filter((item) => item.isUpdate === true);
            const result = [];
            for (let i = 0; i < dataFiltered.length; i += 1) {
                const item = dataFiltered[i];
                const langValue = [];
                langValue[lang] = item.proposalValues;
                item.languageValues[lang] = item.proposalValues;
                result.push({
                    key: item.key,
                    languageValues: {
                        [lang]: item.proposalValues,
                    },
                });
            }

            this.apiCFM.updateLiteralsByImpl(result).then(
                (res) => {
                    if (res !== undefined && Object.keys(res).length > 0) {
                        resolve(res);
                    }
                    reject();
                },
                (error) => {
                    reject(error);
                },
            );
        });

    literalsFiltering = (list, filters, lang) => {
        let result = list;
        const filter = filters.filters;

        if (filter === undefined) {
            return result;
        }

        result = filter.key
            ? result.filter(
                  (literal) =>
                      literal.key.toLowerCase().indexOf(filter.key.value.toLowerCase()) !== -1,
              )
            : result;

        result = filter.currentValue
            ? result.filter(
                  (literal) =>
                      literal.languageValues[lang]
                          .toLowerCase()
                          .indexOf(filter.currentValue.value.toLowerCase()) !== -1,
              )
            : result;

        result = filter.newValue
            ? result.filter(
                  (literal) =>
                      literal.proposalValues
                          .toLowerCase()
                          .indexOf(filter.newValue.value.toLowerCase()) !== -1,
              )
            : result;

        return result;
    };

    reportLiteral = (key) => {
        console.warn(`Reported key "${key}" as not found`);
    };
}
